"use strict";

import { AjaxCall } from 'api/basicApi';
import ApplicationEvents from 'components/applicationEvents';
import { DataSource } from 'generics/utils';

// LogStream.enable( "WALLETAPICALL" );
const loggerWalletApiCall = LogStream("WALLETAPICALL");

////////////////////////////////////////////
// class WalletAPICall
class WalletAPICall  extends AjaxCall {
  constructor ( command )  {
    super( command )

    let crd=SettingsInjections.getCredentials();
    this.appendHeader( "Authorization", "BEARER " + crd.token);
  }


  normalizeResponse( resp )  {
    return resp;
  }


  getInterfaceUrl()  {
    const {  wallet_server  }  =  SettingsInjections.getUsedCircuit();
    return `${wallet_server}${this.command}`;
  }
};


////////////////////////////////////////////
// class WalletStaticCall
class WalletStaticCall  extends AjaxCall {
  constructor ( pathToStatic )  {
    super( pathToStatic )
  }


  normalizeResponse( resp )  {
    return resp;
  }


  getInterfaceUrl()  {
    // const {  wallet_server  }  =  SettingsInjections.getUsedCircuit();
    const wallet_server  =  "config/wallet_";
    return `${wallet_server}${this.command}.json`;
  }
};


////////////////////////////////////////////
//  WalletAPI request  POST: GetBalance access_token=[JWT_TOKEN]
// https://wallet-gotest.gaijin.net/GetBalance
export function WalletGetBalance()  {

  let callGetBalance = new WalletAPICall("GetBalance");

  return callGetBalance.GET().then( (resp) =>  {
      loggerWalletApiCall.info(`WalletGetBalance() - got response:`, resp);
      return resp.balance;
    });
}


export const cachedBalance = new DataSource({});
cachedBalance.on( ( balance ) => {
    // loggerWalletApiCall.debug( "cachedBalance::emit(", balance, ")" );
    ApplicationEvents.emit_async("market.balance", balance );
  })


const EXPIRATION_RECHECK_INTERVAL_MS = (45*60*1000);
let walletNextCheckTime = 0;

export function WalletCheckExpiration( force )  {

  if ( !force && (Date.now() < walletNextCheckTime) )  {
    const balance = cachedBalance.get();
    cachedBalance.set( balance );
    return Promise.resolve( balance );
  }

  walletNextCheckTime = Date.now() + EXPIRATION_RECHECK_INTERVAL_MS;
  return WalletGetBalance().then(
      ( balance ) =>  {
        loggerWalletApiCall.info( "WalletCheckExpiration -> ", balance );
        const gjn = balance || 0;
        cachedBalance.set({ gjn })
        return Promise.resolve( cachedBalance.get() );

      },
      ( reason ) =>  {
        ApplicationEvents.emit_async("auth.tokenExpired");
        walletNextCheckTime = 0;
        cachedBalance.set({})
        return Promise.reject( reason );
      });
}


export function WalletLoadLimits()  {
  let callWalletLimits = new WalletStaticCall( "limits" );

  return callWalletLimits.GET().then( (resp) =>  {
      loggerWalletApiCall.info(`WalletLoadLimits(${name}) - got response:`, resp);
      return resp;
    });
}
